import { Button, Container, Stack, Text, Title } from "@dutyon/ui-kit";
import { MoveLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack align="center" gap="xl" style={{ textAlign: "center" }}>
        <Title
          style={{
            fontSize: "clamp(120px, 20vw, 240px)",
            fontWeight: 900,
            lineHeight: 1,
            background:
              "linear-gradient(135deg, var(--mantine-color-indigo-6), var(--mantine-color-grape-4))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            marginBottom: 0,
            userSelect: "none",
            filter: "drop-shadow(0 10px 20px rgba(0,0,0,0.1))",
          }}
        >
          404
        </Title>
        <Stack gap="xs">
          <Title order={1} style={{ fontSize: "2rem" }}>
            페이지를 찾을 수 없습니다
          </Title>
          <Text c="dimmed" size="lg" maw={500} mx="auto">
            요청하신 관리자 페이지가 존재하지 않거나, 잘못된 경로로 접근하셨습니다. 관리 시스템
            홈으로 이동해 주세요.
          </Text>
        </Stack>
        <Button
          size="lg"
          variant="gradient"
          gradient={{ from: "indigo", to: "grape" }}
          leftSection={<MoveLeft size={20} />}
          onClick={() => navigate("/")}
          style={{
            marginTop: "1rem",
            boxShadow: "0 10px 20px -5px rgba(60, 58, 126, 0.3)",
          }}
        >
          홈으로 돌아가기
        </Button>
      </Stack>
    </Container>
  );
}
